/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
export class DataChangeEvent {
    Group:string
    Mapping: string;
    Data: any;
    Timestamp: Date;

    constructor() {
        this.Timestamp = new Date();
    }
}